import { useClientHasRendered } from '../hooks';

export const useIsTouchDevice = (): boolean => {
  const clientHasRendered = useClientHasRendered();
  return (
    clientHasRendered &&
    matchMedia &&
    matchMedia('(hover: none)') &&
    matchMedia('(hover: none)').matches
  );
};
